import { render, staticRenderFns } from "./record-table.vue?vue&type=template&id=b7859be4"
import script from "./record-table.vue?vue&type=script&lang=js"
export * from "./record-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports